import { render, staticRenderFns } from "./wordCloud.vue?vue&type=template&id=7b463ed6&scoped=true"
import script from "./wordCloud.vue?vue&type=script&lang=js"
export * from "./wordCloud.vue?vue&type=script&lang=js"
import style0 from "./wordCloud.vue?vue&type=style&index=0&id=7b463ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b463ed6",
  null
  
)

export default component.exports